import Box from './shared/layouts/Box';
import Flex from './shared/layouts/Flex';
import Button from './shared/Button';
import { useNavigate } from 'react-router-dom';
import {useTranslation} from "react-i18next";

const NotFound = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Flex
      alignItems="center"
      flexDirection="column"
      justifyContent="center"
      height="100vh"
    >
      <Box fontSize="72px" fontWeight="bold" color="primary">
        404
      </Box>
      <Box mt="m" fontScale="xl" fontWeight="bold">
        {t('Pagina niet gevonden')}…
      </Box>
      <Box width="400px" textAlign="center" mt="m" mb="2xl">
        {t('De pagina die je wilde bezoeken bestaat niet (meer). Keer veilig terug naar je dashboard.')}
      </Box>
      <Button variant="primary" onClick={() => navigate('/dashboard')}>
        {t('Terug naar dashboard')}
      </Button>
    </Flex>
  );
};

export default NotFound;
